import { useLocation } from 'react-router-dom';
import RecentlyViewedProducts from '@/components/RecentlyViewedProducts';

const GlobalRecentlyViewed = () => {
  const location = useLocation();
  
  // Don't show on admin, auth, checkout, or payment pages
  const hiddenPaths = ['/admin', '/auth', '/checkout', '/payment-success', '/specialist'];
  const shouldHide = hiddenPaths.some(path => location.pathname.startsWith(path));
  
  if (shouldHide) return null;

  // Extract product ID from product detail pages to exclude current product
  const productMatch = location.pathname.match(/^\/product\/(.+)$/);
  const excludeProductId = productMatch ? productMatch[1] : undefined;

  return (
    <div className="container mx-auto px-4">
      <RecentlyViewedProducts excludeProductId={excludeProductId} />
    </div>
  );
};

export default GlobalRecentlyViewed;
